/** Shared English UI copy for admin medical-partner forms (avoid duplicating long strings). */

export const PARTNER_CONTACT_IDENTITY_HINT =
  "Same rule as the full profile editor: login identity comes from the directory user, not a separate typed email.";

export const PARTNER_TELECONSULTATION_CREATE_NOTE =
  "Initial TC status below. Per-clinic setup: dossier → Teleconsultation.";

/** Short hint under the TC platform control in the full profile modal (Partner tab). */
export const PARTNER_TC_PLATFORM_IN_PROFILE_MODAL_HINT =
  "Same platform approval as Overview → Status. Saves when you click Save on this tab.";
